import React from "react";
import CategoryPage from "./CategoryPage";

function Videos({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Videos"
      parentCategory="Media"
      parentCategoryValues={[
        "Photos & Videos",
        "PhotosVideos",
        "Media"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default Videos;